export default "__VITE_ASSET__D1TQkjVV__"